import { createContext } from 'react';
export const EditorTrackerContext = /*#__PURE__*/createContext({
  trackEvent: () => null
});